/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeV2IconLinkMenuData } from './moe-v2-icon-link-menu.data';
import { IMoeV2IconLinkMenuProps } from './moe-v2-icon-link-menu.props.autogenerated';

export interface IMoeV2IconLinkMenuViewProps extends IMoeV2IconLinkMenuProps<IMoeV2IconLinkMenuData> {}

/**
 *
 * MoeV2IconLinkMenu component
 * @extends {React.PureComponent<IMoeV2IconLinkMenuProps<IMoeV2IconLinkMenuData>>}
 */
class MoeV2IconLinkMenu extends React.PureComponent<IMoeV2IconLinkMenuProps<IMoeV2IconLinkMenuData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2IconLinkMenu;
